module.exports = __webpack_public_path__ + "img/arrow_2_color.7f6ddf1d.svg";